/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useContext, useEffect, useState } from 'react'
import { Col, Collapse, Nav, Offcanvas, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import baj_logo from '../../assets/baj_logo.png'
import { UserContext } from '../../context/userContext'
import PurchaseOrderIcon from '../../components/atoms/Icons/PurchaseOrderIcon'
import MaterialRequestIcon from '../../components/atoms/Icons/MaterialRequestIcon'
import ItemIssueIcon from '../../components/atoms/Icons/ItemIssueIcon'
import MaterialIssueIcon from '../../components/atoms/Icons/MaterialIssueIcon'
import DisposalIcon from '../../components/atoms/Icons/DisposalIcon'
import BeritaAcaraIcon from '../../components/atoms/Icons/BeritaAcaraIcon'
import TransferIcon from '../../components/atoms/Icons/TransferIcon'
import ArrivalPlanIcon from '../../components/atoms/Icons/ArrivalPlanIcon'
import InboundIcon from '../../components/atoms/Icons/InboundIcon'
import OutboundPlanIcon from '../../components/atoms/Icons/OutboundPlanIcon'
import OutboundIcon from '../../components/atoms/Icons/OutboundIcon'
import WorkOrderPlanIcon from '../../components/atoms/Icons/WorkOrderPlanIcon'
import JobStatusIcon from '../../components/atoms/Icons/JobStatusIcon'
import ReplenishmentIcon from '../../components/atoms/Icons/ReplenishmentIcon'
import StockAdjustmentIcon from '../../components/atoms/Icons/StockAdjustmentIcon'
import StockOpnameIcon from '../../components/atoms/Icons/StockOpnameIcon'
import MasterIcon from '../../components/atoms/Icons/MasterIcon'
import SettingIcon from '../../components/atoms/Icons/SettingIcon'
import StockLedgerIcon from '../../components/atoms/Icons/StockLedgerIcon'
function Drawer(props) {
  const headMenuStyle = {
    backgroundColor: 'var(--primary-orange)',
    color: 'white'
  }
  const headMenuStyleHover = {
    color: 'var(--primary-grey)'
  }
  const { showCanvas, handleCloseCanvas } = props
  const navigate = useNavigate()
  const [state, dispatch] = useContext(UserContext)
  const subMenusData = state.username?.access.reduce((acc, cur) => {
    acc.push({ ...cur, collapse: false })
    return acc
  }, [])
  const [sidebars, setSidebars] = useState(subMenusData)
  const { pathname } = useLocation()
  const headMenu = pathname.split('/')[1]
  const poHeadMenu = pathname.split('/')[2]
  const routeValue = `${headMenu}/${poHeadMenu}`

  // read icon menu
  const icons = (value, isActive, subMenu = null) => {
    switch (value) {
      case 'Purchase Order':
        return <PurchaseOrderIcon isActive={isActive} />
      case 'Material Request':
        return <MaterialRequestIcon isActive={isActive} />
      case 'Item Issue':
        return <ItemIssueIcon isActive={isActive} />
      case 'Material Issue':
        return <MaterialIssueIcon isActive={isActive} />
      case 'Disposal':
        return <DisposalIcon isActive={isActive} />
      case 'Berita Acara':
        return <BeritaAcaraIcon isActive={isActive} />
      case 'Transfer':
        return <TransferIcon isActive={isActive} />
      case 'Arrival Plan':
        return <ArrivalPlanIcon isActive={pathname.includes('arrival')} />
      case 'Inbound':
        return <InboundIcon isActive={pathname.includes('inbound')} />
      case 'Outbound Plan':
        return (
          <OutboundPlanIcon isActive={pathname.includes('outbound/plan')} />
        )
      case 'Outbound':
        return (
          <OutboundIcon
            isActive={
              pathname.includes('outbound') &&
              !pathname.includes('outbound/plan')
            }
          />
        )
      case 'Work Order Plan':
        return <WorkOrderPlanIcon isActive={isActive} />
      case 'Job Status':
        return <JobStatusIcon isActive={isActive} />
      case 'Replenishment':
        return <ReplenishmentIcon isActive={isActive} />
      case 'Stock Ledger':
        return <StockLedgerIcon isActive={pathname.includes('stock-ledger')} />
      case 'Stock Opname':
        return <StockOpnameIcon isActive={isActive} />
      case 'Stock Adjustment':
        return <StockAdjustmentIcon isActive={isActive} />
      case 'Master':
        return <MasterIcon isActive={pathname.includes('master')} />
      case 'Setting':
        return <SettingIcon isActive={pathname.includes('setting')} />
      case 'CMS':
        return <SettingIcon isActive={pathname.includes('manage')} />
      default:
        return <PurchaseOrderIcon isActive={isActive} />
    }
    // return icon
  }

  const collapseAction = (action) => {
    setSidebars(
      sidebars.map((sidebar) =>
        sidebar.menu === action
          ? { ...sidebar, collapse: !sidebar.collapse }
          : sidebar
      )
    )
  }

  const regexSidebarActive = (menu, pathname) => {
    const pattern = menu.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const patternRegex = new RegExp(`^${pattern}(\\/.*)?$`)
    return patternRegex.test(pathname)
  }

  useEffect(() => {
    setSidebars((prevSidebar) =>
      prevSidebar.map((value) =>
        value.menu?.split(' ')[0].toLowerCase() ===
          (headMenu === 'manage' ? 'cms' : headMenu) &&
        /^\/outbound\/plan(\/.*)?$/.test(pathname) === false
          ? { ...value, collapse: true }
          : value
      )
    )
  }, [pathname])

  return (
    <>
      <Offcanvas
        show={showCanvas}
        onHide={handleCloseCanvas}
        style={{ width: '80vw' }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={baj_logo} alt="baj" style={{ width: '50%' }} />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {sidebars?.map((sidebar, index) =>
            !sidebar.submenu.length ? (
              <Col
                md={12}
                className="mb-3"
                key={`menu-${sidebar.sequence}-${index}`}
              >
                <Row
                  style={
                    regexSidebarActive(`/${sidebar.slug}`, pathname)
                      ? headMenuStyle
                      : headMenuStyleHover
                  }
                  className="pt-2 pb-2 rounded-3"
                >
                  <div
                    className="d-flex gap-3 cursor-pointer h-full"
                    role="button"
                    onClick={() => {
                      navigate(`/${sidebar.slug}`, { replace: true })
                      handleCloseCanvas()
                    }}
                  >
                    <div className="d-flex flex-column items-content-center justify-content-center h-full">
                      {icons(
                        sidebar.menu,
                        regexSidebarActive(`/${sidebar.slug}`, pathname)
                      )}
                    </div>
                    <small
                      className={`fw-bold cursor-pointer`}
                      style={{ fontSize: '14px' }}
                    >
                      {sidebar.menu}
                    </small>
                  </div>
                </Row>
              </Col>
            ) : (
              <Col
                md={12}
                onClick={() => collapseAction(sidebar?.menu)}
                role="button"
                className="pointer-auto mb-3"
                key={`menu-${sidebar.sequence}-${index}`} // ✅ Added unique key
              >
                <Row
                  style={
                    headMenu === sidebar?.submenu[0].slug?.split('/')[0] &&
                    /^\/outbound\/plan(\/.*)?$/.test(pathname) === false
                      ? headMenuStyle
                      : headMenuStyleHover
                  }
                  className="pt-2 pb-2 rounded-3"
                >
                  <div className="d-flex flex-row gap-3">
                    <div className="d-flex flex-column items-content-center justify-content-center h-full">
                      {icons(
                        sidebar.menu,
                        regexSidebarActive(`/${sidebar.slug}`, pathname)
                      )}
                    </div>
                    <small className="fw-bold fs-6 ms-1">{sidebar.menu}</small>
                    {sidebar.collapse ? (
                      <ChevronUp className="mt-1" size={16} />
                    ) : (
                      <ChevronDown className="mt-1" size={16} />
                    )}
                  </div>
                </Row>
                <Row>
                  <Col>
                    <Collapse in={sidebar.collapse}>
                      <div id={sidebar.menu}>
                        <Row className="ps-3 pe-3 pt-3">
                          {sidebar.submenu
                            .sort((a, b) => a.sequence - b.sequence)
                            .map((submenu, subIndex) => (
                              <Nav.Link
                                className={`${
                                  subIndex === sidebar.submenu.length - 1 ||
                                  submenu.slug === 'outbound/history'
                                    ? 'mb-0'
                                    : 'mb-3'
                                }`}
                                onClick={() => {
                                  navigate(
                                    submenu.slug ? `/${submenu.slug}` : ''
                                  )
                                  handleCloseCanvas()
                                }}
                                disabled={!submenu.slug}
                                key={`submenu-${submenu.sequence}-${subIndex}`} // ✅ Added unique key
                              >
                                <small
                                  className={
                                    submenu.slug &&
                                    routeValue ===
                                      `${submenu.slug?.split('/')[0]}/${
                                        submenu.slug?.split('/')[1]
                                      }`
                                      ? `text-orange fw-bold`
                                      : 'text-secondary'
                                  }
                                  style={{ fontSize: '14px' }}
                                >
                                  {submenu.menu}
                                </small>
                              </Nav.Link>
                            ))}
                        </Row>
                      </div>
                    </Collapse>
                  </Col>
                </Row>
              </Col>
            )
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Drawer
